import React, { FC, useMemo } from 'react';
import { useMediaPredicate } from 'react-media-hook';
import { MEDIA_MOBILE_768 } from 'common/const/common.const';
import { Store } from 'common/models/commonModel';
import { StoreSelectorCir } from 'entities/Store/components/Selector/StoreSelectorCir';
import { StoreSelectorMob } from 'entities/Store/components/Selector/StoreSelectorMob';

interface IComponentProps {
  stores?: Store[];
  onChange: (value?: string | number) => void;
  // MBC-84: when true, both desktop and mobile selectors expose "All stores" option.
  allowAll?: boolean;
  allowClear?: boolean;
}

export const PageStoreSelector: FC<IComponentProps> = ({ stores = [], onChange, allowAll, allowClear }) => {
  const isMobile: boolean = useMediaPredicate(MEDIA_MOBILE_768);

  const options = useMemo(
    () => stores.map((item) => ({ value: item.code, label: 'displayName' in item ? item.displayName : item.name })),
    [stores]
  );

  return (
    <div className="page-store-selector">
      {isMobile ? (
        <StoreSelectorMob options={options} onChange={onChange} allowAll={allowAll} allowClear={allowClear} />
      ) : (
        <StoreSelectorCir options={options} onChange={onChange} allowAll={allowAll} allowClear={allowClear} />
      )}
    </div>
  );
};
